export function parseArgsDate(input: Date | string): Date {
  if (input instanceof Date) {
    return input;
  }

  return new Date(input);
}
